exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".required{\n    color: red;\n}\n.example-full-width{\nwidth:100%;   \n}\n.modal-width{\nwidth:40%;   \n}\n.modal-body {\n    padding: 10px 10px;\n}\n.modal-body a {\n    font-weight: bold;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-public-quote/public-client-account/public-client-account.component.css
// module id = ../../../../../src/app/mnt-public-quote/public-client-account/public-client-account.component.css
// module chunks = mnt-public-quote.module